export enum SortOrder {
  ASC = 'ascending',
  DSC = 'descending'
}

export interface SortCriteria {
  /** define which field sort by, undefined means whole object */
  param?: string;

  /** optional transformation function, applied after param
   * @warning must handle potential null!
   * */
  transform?: ((x: any) => string) | ((x: any) => number);

  /** sorting order */
  order: SortOrder;

  /** for complex comparisons - bundle of strings/numbers separated with other character, eg. location in news*/
  separator?: string;
}
